// Методы для помощи экспорта в эксель
import { mapGetters } from 'vuex';
import TableToExcel from "@linways/table-to-excel"

export const excelExportHelpers = {
    data() {
        return {
            isExportData: false
        }
    },
    computed: {
        ...mapGetters('auth', ['currentUser']),
    },
    methods: {
        formatNumbers(value) {
            if (!this.isExportData) {
                let formatter = new Intl.NumberFormat('ru-RU', {
                    minimumFractionDigits: 0
                })
                return formatter.format(value)
            }

            return value
        },
        exportTable(tableId, fileName = 'export', sheetName = 'Лист 1') {
            if (
                this.currentUser.role.includes("administrator") ||
                this.currentUser.role.includes("client") ||
                this.currentUser.id === 11 || // Ольга Зуева
                this.currentUser.id === 12 || // Игорь Шустов
                this.currentUser.id === 17 || // Елена Кретова 
                this.currentUser.id === 18    // Рената Курбаева            
            ) {
                this.isExportData = true

                let exportExcel = new Promise((resolve, reject) => {
                    setTimeout(() => {
                        TableToExcel.convert(document.getElementById(tableId), {
                            name: fileName + ".xlsx",
                            sheet: {
                                name: sheetName
                            }
                        })
    
                        resolve("result")
                    }, 500)
                })
    
                exportExcel.then(
                    result => {
                        this.isExportData = false
                    }
                );
            } else {
                this.$bvToast.toast('К сожалению, вам не хватает прав для экспорта данных. Обратитесь к руководству.', {
                    title: 'Недостаточно прав',
                    variant: 'warning',
                    solid: true
                })                
            }         
        },

    }
}
